
namespace GeniuzPOS.Purchase {

    @Serenity.Decorators.registerEditor()
    export class PoPurOrderEditors extends Serenity.LookupEditorBase<Serenity.LookupEditorOptions, PoPurOrderRow>{

        constructor(hidden: JQuery) {
            super(hidden);
        }

        protected getLookupKey() {
            return PoPurOrderRow.lookupKey;
        }

        // protected getItemText(item, lookup) {
        //     return super.getItemText(item, lookup) + ' [' + item.MbFirstName+']';
        // }
    }
}
